import ListSymptoms from './ListSymptoms';
import ShowSymptoms from './ShowSymptoms';

export default {
  list: ListSymptoms,
  show: ShowSymptoms,
};
